import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";
import App from "./App.vue";
import router from "./router";
import formValidator from "./mixins/form-validator";
import store from "./store";
import ABTesting from "./plugins/ab-testing";
import AdobeLaunch from "./plugins/adobe-launch";
import config from "./config";
import pixels from "./pixels";
import "@openmarket/styleguide";

const isProduction = PRODUCTION;

if (isProduction) {
  require("./libs/tealeaf");
}

// Configuración del módulo
Vue.use(config);

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
});

Vue.use(ABTesting);
Vue.use(AdobeLaunch);

// Pixeles
// (llamar al último)
Vue.use(pixels);

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    render: h => h(App)
  }).$mount("#bbva");

  // Google Analytics
  // Necesitamso el config del id
  // por eso llamamos acá
  if (config.get() && config.get().googleAnalyticsId) {
    Vue.use(VueAnalytics, {
      id: config.get().googleAnalyticsId,
      router,
      autoTracking: {
        exception: true,
        pageviewOnLoad: false
      }
    });
  }

  // Agregar timestamp de versionado si existe
  let app_version = _BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
